<div class="ig-infinite-scroll h-full w-full relative">
  <ng-container *ngIf="mode==='virtual'">
    <ng-container *ngIf="data$ | async as events" class="ig-infinite-scroll h-full">
      <cdk-virtual-scroll-viewport itemSize="52" class="h-full w-full"
        (scrolledIndexChange)="scrolledIndexChange($event)">
        <div *cdkVirtualFor="let item of events;let i = index;trackBy:trackByIndex"
          class="h-[300px] border-2 border-black">
          <ig-image [src]="item.cover.source" cls="w-full object-fill aspect-[4/3]"></ig-image>
          {{item.name}} - {{i}}
        </div>
      </cdk-virtual-scroll-viewport>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="mode==='normal'">
    <ng-container *ngIf="{data: data$ | async, settings: frontendSettings} as vm">
      <div class="grid overflow-y-auto p-4 duration-200 pb-24 load-animation" [class.load-animation]="reloadAnimation"
        #container [class.long-card-grid]="cardStyle==='long'" [class.modern-block-grid]="cardStyle==='modern-block'"
        [class.modern-block-grid]="cardStyle==='tile'" [class.square-card-grid]="cardStyle==='square'"
        [class.fancy-card-grid]="cardStyle==='fancy'" [class.vertical-card-grid]="cardStyle==='vertical'"
        [class.hub-card-grid]="cardStyle==='hub'" [class.topbar-mode]="!vm.settings?.customSettings.menuStyle.isSideBar"
        [class.topbar-mode]="!vm.settings?.customSettings.menuStyle.isSideBar"
        [class.h-full]="vm.settings?.customSettings.menuStyle.isSideBar">
        <ng-container *ngIf="cardStyle==='default'">
          <ig-visitor-default-card *ngFor="let item of vm.data;let i = index;trackBy:trackByIndex"
            [class.promotion]="item.socialName==='promotion'" [item]="item"
            [editorChoiceText]="vm.settings.customSettings.customEditorChoice"
            [detailsPageStyle]="vm.settings.customSettings.calendarStyle.eventDetails"
            [searchFields]="searchFields"></ig-visitor-default-card>
        </ng-container>
        <ng-container *ngIf="cardStyle==='square'">
          <ig-visitor-square-card *ngFor="let item of vm.data;let i = index;trackBy:trackByIndex" [item]="item"
            [class.promotion]="item.socialName==='promotion'"
            [editorChoiceText]="vm.settings.customSettings.customEditorChoice"
            [searchFields]="searchFields"></ig-visitor-square-card>
        </ng-container>
        <ng-container *ngIf="cardStyle==='long'">
          <ig-visitor-long-card *ngFor="let item of vm.data;let i = index;trackBy:trackByIndex" [item]="item"
            [class.promotion]="item.socialName==='promotion'"
            [editorChoiceText]="vm.settings.customSettings.customEditorChoice"
            [detailsPageStyle]="vm.settings.customSettings.calendarStyle.eventDetails"
            [searchFields]="searchFields"></ig-visitor-long-card>
        </ng-container>
        <ng-container *ngIf="cardStyle==='modern-block'||cardStyle==='tile'">
          <ig-visitor-modern-block-card *ngFor="let item of vm.data;let i = index;trackBy:trackByIndex" [item]="item"
            [allItems]="vm.data" [class.promotion]="item.socialName==='promotion'"
            [editorChoiceText]="vm.settings.customSettings.customEditorChoice"
            [detailsPageStyle]="vm.settings.customSettings.calendarStyle.eventDetails"
            [searchFields]="searchFields"></ig-visitor-modern-block-card>
        </ng-container>
        <ng-container *ngIf="cardStyle==='fancy'">
          <ig-visitor-fancy-card *ngFor="let item of vm.data;let i = index;trackBy:trackByIndex"
            [class.promotion]="item.socialName==='promotion'" [class.span-2]="item.socialName==='promotion'"
            [attr.socialName]="item.socialName" [item]="item" [allItems]="vm.data"
            [editorChoiceText]="vm.settings.customSettings.customEditorChoice"
            [favCustomEvents]="vm.settings.customSettings.customEvents"
            [detailsPageStyle]="vm.settings.customSettings.calendarStyle.eventDetails"
            [searchFields]="searchFields"></ig-visitor-fancy-card>
        </ng-container>
        <ng-container *ngIf="cardStyle==='vertical'">
          <ig-visitor-vertical-card *ngFor="let item of vm.data;let i = index;trackBy:trackByIndex"
            [class.promotion]="item.socialName==='promotion'" [attr.socialName]="item.socialName" [item]="item"
            [allItems]="vm.data" [editorChoiceText]="vm.settings.customSettings.customEditorChoice"
            [detailsPageStyle]="vm.settings.customSettings.calendarStyle.eventDetails"
            [searchFields]="searchFields"></ig-visitor-vertical-card>
        </ng-container>
        <ng-container *ngIf="cardStyle==='hub'">
          <ig-hub-event-card *ngFor="let item of vm.data;let i = index;trackBy:trackByIndex"
            [attr.socialName]="item.socialName" [item]="item" [hubName]="hubName"
            [customEvents]="vm.settings.customSettings.customEvents"
            [customPlaces]="vm.settings.customSettings.customPlaces" [searchFields]="searchFields"
            [editorChoiceText]="vm.settings.customSettings.customEditorChoice"></ig-hub-event-card>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>

  <div *ngIf="isLoadingItems&&isShowSkeleton" class="absolute top-0 left-0 w-full h-full bg-[#eef5f9]">
    <div class="px-[3vw] py-[1vw]">
      <ig-loading-block></ig-loading-block>
    </div>
  </div>

  <ig-spinner *ngIf="!isAllDataLoaded&&isLoadingItems&&!isShowSkeleton" class="absolute left-[50%] bottom-[16vh]"
    [diameter]="48" [strokeWidth]="4"></ig-spinner>

  <div *ngIf="data$ | async as events" [class.hidden]="events.length||isLoadingItems"
    class="absolute top-0 left-0 w-full h-full">
    <ig-no-content></ig-no-content>
  </div>
</div>